export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      // minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      paddingBottom: theme.spacing(8),
      background: theme.palette.green.dark,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    background: `no-repeat url(${theme.url('/blocks/b24-bg.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top right',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  greyCurve: {
    position: 'absolute',
    zIndex: 2,
    bottom: 0,
    right: 0,
    height: '55%',
    width: '50%',
    background: `no-repeat url(${theme.url('/blocks/b24-grey-curve.svg')})`,
    backgroundSize: 'contain',
    backgroundPosition: 'right',
  },
  content: {
    position: 'relative',
    zIndex: 5,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      minWidth: 'initial',
      height: 'initial',
      right: 'initial',
      paddingBottom: theme.spacing(2),
    },
  },
  desc: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    height: '100%',
    width: '33%',
    backgroundColor: theme.palette.green.dark,
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
      padding: theme.spacing(4),
      // margin: theme.spacing(2),
    },
  },
  text: {
    position: 'absolute',
    minWidth: '60%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      minWidth: 'initial',
      top: 0,
      left: 0,
      transform: 'initial',
    },
  },
  mainTitle: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      textAlign: 'right',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  aside: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: '33%',
    height: '40%',
    width: '33%',
    backgroundColor: theme.palette.green.dark,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      left: 0,
      height: 'initial',
    },
  },
  btn: {
    maxWidth: '300px',
    position: 'absolute',
    minWidth: '60%',
    top: '60%',
    left: '10%',
  },
});
